import { fg } from '@atlassian/jira-feature-gating';

export const getCurrentUrl = (): string => {
	if (typeof window !== 'undefined') {
		return window.location.href;
	}
	return '';
};

export const isValidNthUserWelcomePath = (path: string): boolean => {
	try {
		const url = new URL(path);
		const pathname = url.pathname;
		const regex =
			/^(?:\/jira\/[^/]+\/(?:c\/)?projects\/[^/]+\/(board|boards(?:\/[^/]+(?:\/backlog)?)?|board\/[^/]+\/backlog)\/?|\/browse\/[^/]+\/?)$/;

		return regex.test(pathname);
	} catch {
		return false;
	}
};

export const getContinueUrlWithWelcomeModal = (path?: string | null): string => {
	const currentUrl = path || getCurrentUrl();
	if (
		!fg('jira_nth_user_workitem_recommendation_killswitch') ||
		!isValidNthUserWelcomePath(currentUrl)
	) {
		return currentUrl;
	}

	const url = new URL(currentUrl);
	url.searchParams.append('showNthUserWelcomeModal', 'true');
	return url.toString();
};
